import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { WindowStackItem } from '@ff-os/shared-react/context/window-stack/WindowStackItem';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { selectActiveBorderOptionForVariantId } from '../../../_redux-borders';
import { selectActiveVariant, selectCanRemoveGroup } from '../../../_redux-groups';
import { selectActivePaperOptionForVariantId } from '../../../_redux-papers';
import { selectActiveSizeOptionForVariantId } from '../../../_redux-sizes';
import { VariantOption } from '../../../VariantOption';
import { ChangeVariantWindow } from '../../change-variant-window/ChangeVariantWindow';
import { useGroupTitle } from '../helpers/useGroupTitle';
import { PhotoPrintGroupMobileOverlay } from './PhotoPrintGroupMobileOverlay';
import styles from './PhotoPrintsGroupWindowPanelHeader.module.scss';

const _PhotoPrintsGroupDetailWindowHeader = ({ size, paper, border, groupId, activeVariant, canRemove, close }: Props) => {

    const [isOptionsWindowOpen, setOptionsWindowOpen] = useState(false);
    const [isEditWindowOpen, setEditWindowOpen] = useState(false);
    const title = useGroupTitle({ groupId, size, paper, border });

    const isAccessory = size?.isAccessory ?? false;
    const hasBorder = activeVariant.borderId !== "without-border";
    const showEditIcon = !isAccessory || canRemove || hasBorder;

    const closeGroup = () => {
        setOptionsWindowOpen(false);
        setEditWindowOpen(false);
        close();
    };

    const openOptionWIndow = () => {
        if (showEditIcon) {
            setOptionsWindowOpen(true);
        }
    };

    return (
        <div className={styles.panelHeading}>
            <Icon className={styles.icon} type='shopping-cart' size='large' strokeWidth={2} />
            <div className={styles.heading} onClick={openOptionWIndow}>
                <h4 className={styles.groupName}>
                    {title}
                </h4>
                {showEditIcon && (
                    <Icon type='general-ui-cog' strokeWidth={1} className={styles.groupEdit} />
                )}
            </div>

            <PhotoPrintGroupMobileOverlay
                isOpen={isOptionsWindowOpen}
                groupId={groupId}
                setOpen={setOptionsWindowOpen}
                isAccessory={isAccessory}
                openEditWindow={() => setEditWindowOpen(true)}
                closeGroup={closeGroup} />

            {isEditWindowOpen && (
                <WindowStackItem>
                    <ChangeVariantWindow
                        close={() => setEditWindowOpen(false)}
                        groupId={groupId} sizeId={size.value} paperId={paper.value} />
                </WindowStackItem>
            )}
        </div>
    );
};

type OwnProps = {
    groupId: string;
    variantId: string;
    close: () => void;
};

type Props = OwnProps & {
    size: VariantOption;
    paper: VariantOption;
    border?: VariantOption;
    activeVariant: PhotoPrintsJson.Variant;
    canRemove: boolean;
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    size: selectActiveSizeOptionForVariantId(state, ownProps.variantId)!,
    paper: selectActivePaperOptionForVariantId(state, ownProps.variantId)!,
    border: selectActiveBorderOptionForVariantId(state, ownProps.variantId),
    activeVariant: selectActiveVariant(state, ownProps.groupId),
    canRemove: selectCanRemoveGroup(state, ownProps.groupId)
});

export const PhotoPrintsGroupWindowPanelHeader = connect(
    mapStateToProps
)(_PhotoPrintsGroupDetailWindowHeader);